import React, { useCallback, useEffect, useRef, useState } from "react";
import "./styles.scss";

import FilePresentIcon from "@mui/icons-material/FilePresent";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Button from "@mui/material/Button";

function FileField({ field, onHandleChange = () => {} }) {
  const [value, setValue] = useState([]);
  const [files, setFiles] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    if (field.multiple) {
      setValue(field.value);
      setFiles(field.value);
    } else {
      if (field.value) {
        setValue([field.value]);
        setFiles([field.value]);
      }
    }
  }, []);

  const handleChange = useCallback(
    (val) => {
      let arr = Array.from(val).map((file) => {
        return {
          file_name: file.name,
          id: file.name,
          url: URL.createObjectURL(file),
        };
      });
      if (field.multiple) {
        let allValues = [...value, ...arr];
        setValue((prev) => allValues);

        let allFiles = [...files, ...val];
        setFiles((prev) => allFiles);
        onHandleChange(allFiles);
      } else {
        setValue((prev) => arr);
        setFiles(val);
        onHandleChange(val);
      }
    },
    [value],
  );

  const removeFile = (index) => {
    const fileListArr = Array.from(files);
    fileListArr.splice(index, 1);
    setFiles(fileListArr);
    onHandleChange(fileListArr);

    value.splice(index, 1);
    setValue((prev) => value);
  };

  return (
    <div className="file-field">
      <div className={`file-field__files ${field.sub_type}`}>
        {value?.map((el, index) => (
          <div key={el.id}>
            <div className="file-field__preview">
              <a href={el.url} target="blank">
                {field.sub_type === "image" && (
                  <img src={el.url} alt={el.file_name} />
                )}
                {field.sub_type !== "image" && <>{el.file_name}</>}
              </a>
              <HighlightOffRoundedIcon onClick={() => removeFile(index)} />
            </div>
          </div>
        ))}
      </div>

      <label htmlFor={"icon-button-file-" + field.id}>
        <Button variant="outlined" component="span">
          Upload File <FilePresentIcon />
        </Button>

        <input
          ref={ref}
          hidden={true}
          id={"icon-button-file-" + field.id}
          multiple={!!field.multiple}
          onChange={(e) => handleChange(e?.target?.files)}
          type="file"
          accept={field.sub_type === "image" ? "image/*" : "*"}
        />
      </label>
    </div>
  );
}

export default FileField;
